import { loadFollowsList } from '@nostr/gadgets/lists'

export async function sampleTopFromFollows<T>(
  accountPubkey: string,
  fetcher: (pubkey: string) => Promise<T[]>,
  keyExtractor: (item: T) => string,
  excludeKeys: Set<string>,
  sampleSize = 20,
  topN = 10
): Promise<T[]> {
  const follows = (await loadFollowsList(accountPubkey)).items
  if (follows.length === 0) return []

  const sample = [...follows].sort(() => Math.random() - 0.5).slice(0, sampleSize)

  const lists = await Promise.all(sample.map(fetcher))

  const counts = new Map<string, { item: T; count: number }>()
  for (const items of lists) {
    const seen = new Set<string>()
    for (const item of items) {
      const key = keyExtractor(item)
      if (seen.has(key)) continue
      seen.add(key)
      if (excludeKeys.has(key)) continue
      const existing = counts.get(key)
      if (existing) existing.count++
      else counts.set(key, { item, count: 1 })
    }
  }

  return [...counts.values()]
    .sort((a, b) => b.count - a.count)
    .slice(0, topN)
    .map((x) => x.item)
}
